import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { FormGroup, FormBuilder } from '@angular/forms';

@Component({
	selector: 'rpfsa-quote-report-dialog',
	templateUrl: './quote-report-dialog.component.html',
})
export class QuoteReportDialogComponent {
	constructor(
		private fb: FormBuilder,
		private quoteReportDialogRef: MatDialogRef<QuoteReportDialogComponent>
	) {}

	quoteReportForm: FormGroup = this.fb.group({
		addToDocuments: [false],
	});

	close() {
		this.quoteReportDialogRef.close();
	}

	generateQuoteReport() {
		this.quoteReportDialogRef.close(this.quoteReportForm);
	}
}
